<template>
  <sf-accordion-item
    :checked="checked"
    :current-active-index="effectiveActiveIndex"
    :index="index"
    :last="last"
    @item-clicked="handleItemClick"
  >
    <template #title>
      <slot name="title" />
    </template>

    <template #description>
      <slot name="description" />
    </template>

    <template #content>
      <slot name="content" />
    </template>
  </sf-accordion-item>
</template>
<script lang="ts" setup>
import { computed, inject } from 'vue'

import { useAccordion } from '@app/shared/pinia/accordion'
import SfAccordionItem from '@app/shared/vue/components/sf-accordion/sf-accordion-item.vue'
import getPiniaInstance from '@app/shared/pinia/instance'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfCeAccordionItem',
})

interface Props {
  checked?: boolean
  index: string
  last?: boolean
}

defineProps<Props>()

const accordionId = inject<string>('accordionId')

const accordionStore = useAccordion(getPiniaInstance())

const effectiveActiveIndex = computed(() => {
  if (!accordionId) {
    return '0'
  }

  return accordionStore.accordions[accordionId]?.currentAccordionIndex
})

const handleItemClick = (index: string) => {
  if (!accordionId) {
    return
  }

  accordionStore.toggleIndex(index, accordionId)
}
</script>
<style lang="scss">
@import '@app/shared/vue/components/sf-accordion/sf-accordion-item';
</style>
